// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"328":"59337436","702":"70d0f086","737":"05147436"}[chunkId] + ".chunk.css";
};